import {Platform} from 'react-native';
import {IMAGE_OPTIONS} from '../constants';

type PickAndroidImageResult = {
  base64: string | null;
  cancelled: boolean;
  error: Error | null;
  fileName: string | null;
  mimeType: string | null;
};

const EMPTY_RESULT: PickAndroidImageResult = {
  base64: null,
  cancelled: false,
  error: null,
  fileName: null,
  mimeType: null,
};

const pickAndroidImage = async (): Promise<PickAndroidImageResult> => {
  if (Platform.OS !== 'android') {
    return {
      ...EMPTY_RESULT,
      cancelled: true,
      error: new Error('Android image picker is only available on Android.'),
    };
  }

  try {
    const ImagePicker = require('react-native-image-crop-picker').default;
    const image = await ImagePicker.openPicker(IMAGE_OPTIONS);

    return {
      base64: image?.data || null,
      cancelled: false,
      error: null,
      fileName: image?.filename || image?.path?.split('/').pop() || null,
      mimeType: image?.mime || 'image/jpeg',
    };
  } catch (error) {
    if (
      typeof error?.toString === 'function' &&
      error.toString().toLowerCase().includes('cancel')
    ) {
      return {
        ...EMPTY_RESULT,
        cancelled: true,
      };
    }

    return {
      ...EMPTY_RESULT,
      error:
        error instanceof Error
          ? error
          : new Error('Unable to select an image from your device.'),
    };
  }
};

export default pickAndroidImage;
